import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { Helmet } from "react-helmet";

const Package = () => {
  const [product, setProduct] = useState({});
  const [orderDate, setOrderDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams();
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState([]);
  const PAYMENT_PROCESSING_FEE_RATE = 0.0;

  useEffect(() => {
    fetch(`https://ecom-22-fe6311cae608.herokuapp.com/package/${id}`)
      .then((res) => res.json())
      .then((info) => setProduct(info));
  }, [id]);

  useEffect(() => {
    fetch(`https://ecom-22-fe6311cae608.herokuapp.com/users`)
      .then((res) => res.json())
      .then((info) => setUserInfo(info));
  }, [user]);

  useEffect(() => {
    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const year = currentDate.getFullYear();
    setOrderDate(`${day}/${month}/${year}`);
  }, []);

  const generateUniquePaymentId = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let paymentId = "";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      paymentId += characters.charAt(randomIndex);
    }
    return paymentId;
  };

  const generateUniqueOrderId = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let orderId = "";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      orderId += characters.charAt(randomIndex);
    }
    return orderId;
  };

  const handleOrder = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const paymentId = generateUniquePaymentId();
    const orderId = generateUniqueOrderId();

    // Calculate payment processing fee
    const originalPrice = parseFloat(product.price);
    const processingFee = originalPrice * PAYMENT_PROCESSING_FEE_RATE;
    const totalPrice = originalPrice + processingFee;

    const formData = {
      paymentId,
      orderId,
      packageId: product._id,
      credit: Number(product.credit),
      packageName: product.packageName,
      sellerEmail: product.sellerEmail,
      packagePrice: product.price,
      processingFee: processingFee.toFixed(2),
      totalPrice: totalPrice.toFixed(2),
      paymentStatus: "pending",
      orderStatus: "pending",
      customerEmail: user?.email,
      customerName: event.target.customerName.value,
      address: event.target.address.value,
      country: event.target.country.value,
      orderDate: orderDate,
      Validity: product.validity,
    };

    try {
      await fetch("https://ecom-22-fe6311cae608.herokuapp.com/new-order", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      navigate("/user/package-pending-payment/");
    } catch (error) {
      console.error("Error submitting order:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const currentUser = userInfo.find((u) => u.UserEmail === user?.email);
  const isSeller = currentUser?.userRole === "Seller";

  // Calculate price details
  const originalPrice = parseFloat(product.price || 0);
  const processingFee = originalPrice * PAYMENT_PROCESSING_FEE_RATE;
  const totalPrice = originalPrice + processingFee;

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  return (
    <div className="mt-5">
      <Helmet>
        <title>Complete Your Order | Quick and Easy Checkout</title>
        <meta
          name="description"
          content="Complete your order on  with our simple and secure checkout process. Enjoy instant access to your digital products after payment."
        />
      </Helmet>
      <main style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10">
              <div
                className="card shadow-sm border-0"
                style={{ borderRadius: "15px" }}
              >
                <div
                  className="card-header bg-primary text-dark py-4"
                  style={{ borderRadius: "15px 15px 0 0" }}
                >
                  <h2
                    className="text-center mb-0"
                    style={{ fontSize: "24px", fontWeight: "600" }}
                  >
                    Complete Your Order
                  </h2>
                </div>
                <div className="card-body p-4 p-md-5">
                  {isSeller ? (
                    <div
                      className="alert alert-warning text-center py-4"
                      style={{ borderRadius: "8px" }}
                    >
                      <i className="fa fa-exclamation-triangle me-2"></i>
                      Sellers cannot purchase products
                    </div>
                  ) : (
                    <form onSubmit={handleOrder}>
                      <div className="mb-4 pb-2">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: "32px",
                              height: "32px",
                              minWidth: "32px",
                            }}
                          >
                            <span>1</span>
                          </div>
                          <h4 className="mb-0 text-dark">
                            Package Information
                          </h4>
                        </div>
                        <div
                          className="bg-light p-4"
                          style={{ borderRadius: "10px" }}
                        >
                          <div className="form-floating mb-3">
                            <input
                              type="text"
                              className="form-control"
                              id="packageName"
                              value={product.packageName || ""}
                              disabled
                              style={{ height: "60px" }}
                            />
                          </div>

                          <div
                            className="card mb-0"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid #e0e0e0",
                            }}
                          >
                            <div className="card-body">
                              <h5 className="mb-3 text-center">
                                Price Details
                              </h5>
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span>Package Price:</span>
                                <span className="fw-medium">
                                  ${originalPrice.toFixed(2)}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mb-2"></div>
                              <hr />
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="fw-bold">Total Price:</span>
                                <span className="fw-bold fs-5 text-primary">
                                  ${totalPrice.toFixed(2)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-4 pb-2">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="bg-primary text-dark rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: "32px",
                              height: "32px",
                              minWidth: "32px",
                            }}
                          >
                            <span>2</span>
                          </div>
                          <h4 className="mb-0 text-dark">
                            Billing Information
                          </h4>
                        </div>
                        <div
                          className="bg-light p-4"
                          style={{ borderRadius: "10px" }}
                        >
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="customerName"
                                  name="customerName"
                                  placeholder="Full Name"
                                  defaultValue={currentUser?.userName || ""}
                                  required
                                  style={{ height: "60px" }}
                                />
                                <label htmlFor="customerName">Full Name</label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating">
                                <input
                                  type="email"
                                  className="form-control"
                                  id="email"
                                  value={user?.email || ""}
                                  disabled
                                  style={{ height: "60px" }}
                                />
                                <label htmlFor="email">Email</label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-floating">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="address"
                                  name="address"
                                  placeholder="Address"
                                  defaultValue={currentUser?.address || ""}
                                  required
                                  style={{ height: "60px" }}
                                />
                                <label htmlFor="address">Address</label>
                              </div>
                            </div>
                            <select
                              className="form-select"
                              id="country"
                              name="country"
                              defaultValue={currentUser?.country || ""}
                              required
                              style={{ height: "60px" }}
                            >
                              <option value="">Select Country</option>
                              {countries.map((country) => (
                                <option key={country} value={country}>
                                  {country}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg"
                          disabled={isSubmitting}
                          style={{
                            borderRadius: "8px",
                            padding: "14px 20px",
                            fontSize: "18px",
                            boxShadow:
                              "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)",
                          }}
                        >
                          {isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Processing...
                            </>
                          ) : (
                            <div className="d-flex align-items-center justify-content-center">
                              <span className="me-2">Proceed to Payment</span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={18}
                                height={18}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M5 12h14"></path>
                                <path d="m12 5 7 7-7 7"></path>
                              </svg>
                            </div>
                          )}
                        </button>
                      </div>

                      <div className="text-center mt-4">
                        <div className="d-flex justify-content-center align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={18}
                            height={18}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="me-2"
                          >
                            <rect
                              width="20"
                              height="14"
                              x="2"
                              y="5"
                              rx="2"
                            ></rect>
                            <line x1="2" x2="22" y1="10" y2="10"></line>
                          </svg>
                          <span className="text-muted">
                            Secure payment processing
                          </span>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Package;
